var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-full" }, [
    _vm.groupBy === "date"
      ? _c(
          "table",
          { staticClass: "w-full", attrs: { id: "blum-cumulative-table" } },
          [
            _c("thead", [
              _c("tr", [
                _c(
                  "td",
                  [_c("BlTextSubtitle2", { attrs: { text: "Date mastered" } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  [_c("BlTextSubtitle2", { attrs: { text: "Target" } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "min-w-48" },
                  [
                    _c("BlTextSubtitle2", {
                      attrs: { text: "Date introduced" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  [_c("BlTextSubtitle2", { attrs: { text: "Curriculum" } })],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _vm._l(_vm.cumulativeTable, function(targetBody, bodyIndex) {
              return _c(
                "tbody",
                { key: bodyIndex },
                _vm._l(targetBody.targets, function(target, index) {
                  return _c("tr", { key: index }, [
                    index === 0
                      ? _c(
                          "td",
                          {
                            staticClass: "border-r bg-grey-100",
                            attrs: { rowspan: targetBody.number_of_target }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "flex items-center gap-2" },
                              [
                                _c("BlTextBody1", {
                                  staticClass: "text-grey-400",
                                  attrs: {
                                    text: _vm.displayDate(targetBody.key)
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlBubbleCount", {
                                  attrs: {
                                    count:
                                      (bodyIndex > 0 ? "+" : "") +
                                      targetBody.number_of_target
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("BlTextBody1", {
                          staticClass: "text-grey",
                          attrs: { text: target.name }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("BlTextBody1", {
                          staticClass: "text-grey-400",
                          attrs: {
                            text: _vm.displayDate(target.date_introduce)
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "span",
                        { staticClass: "flex gap-2" },
                        [
                          _c("div", {
                            staticClass: "w-6 h-6 flex-shrink-0 rounded-full",
                            style: { backgroundColor: target.curriculum_color }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody1", {
                            staticClass: "text-grey-400",
                            attrs: { text: target.curriculum_name }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                }),
                0
              )
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.groupBy === "curriculum"
      ? _c(
          "div",
          { staticClass: "w-full space-y-4" },
          [
            _c(
              "div",
              {
                staticClass:
                  "grid grid-cols-8 gap-6 py-2 px-6 bg-grey-100 rounded",
                attrs: { id: "cumulative-curriculum-header" }
              },
              [
                _c(
                  "div",
                  { staticClass: "col-span-4 text-grey-400 font-semibold" },
                  [_c("BlTextSubtitle2", { attrs: { text: "Target" } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-span-2 text-grey-400 font-semibold" },
                  [
                    _c("BlTextSubtitle2", {
                      attrs: { text: "Date introduced" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-span-2 text-grey-400 font-semibold" },
                  [_c("BlTextSubtitle2", { attrs: { text: "Date mastered" } })],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.sortAlphabeticalTable, function(targetBody, bodyIndex) {
              return _c(
                "div",
                {
                  key: bodyIndex,
                  staticClass: "rounded border border-grey-200"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "grid grid-cols-8 gap-6 py-4 px-6 border-b border-grey-200"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex gap-2 col-span-6" },
                        [
                          _c("div", {
                            staticClass: "w-6 h-6 flex-shrink-0 rounded-full",
                            style: {
                              backgroundColor: targetBody.targets.at(0)
                                .curriculum_color
                            }
                          }),
                          _vm._v(" "),
                          _c("BlTextSubtitle2", {
                            staticClass: "text-grey font-semibold",
                            attrs: { text: targetBody.key }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex items-center gap-2 col-span-2" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "relative bg-light-purple-100 h-2 w-full rounded-full"
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "aboslute bg-light-purple-300 h-2 rounded-full",
                                style: {
                                  width:
                                    (targetBody.number_of_mastered /
                                      targetBody.number_of_target) *
                                      100 +
                                    "%"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-1" },
                            [
                              _c("BlBubbleCount", {
                                attrs: {
                                  count: targetBody.number_of_mastered || 0
                                }
                              }),
                              _vm._v(" "),
                              _c("div", [_vm._v("/")]),
                              _vm._v(" "),
                              _c("BlBubbleCount", {
                                attrs: {
                                  type: "secondary",
                                  count: targetBody.number_of_target || 0
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(targetBody.targets, function(target, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "grid grid-cols-8 gap-6 py-4 px-6"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex gap-2 col-span-4" },
                          [
                            _c("BlTextBody1", {
                              staticClass: "text-grey",
                              attrs: { text: target.name }
                            }),
                            _vm._v(" "),
                            target.status !== "mastered"
                              ? _c(
                                  "div",
                                  { staticClass: "flex-shrink-0" },
                                  [
                                    _c("StatusChip", {
                                      attrs: {
                                        status: target.status,
                                        dense: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-span-2" },
                          [
                            _c("BlTextBody1", {
                              staticClass: "text-grey-400",
                              attrs: {
                                text: _vm.displayDate(target.date_introduce)
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-span-2" },
                          [
                            _c("BlTextBody1", {
                              staticClass: "text-grey-400",
                              attrs: {
                                text: _vm.displayDate(target.date_mastered)
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  })
                ],
                2
              )
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-062d4436", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-062d4436","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/cumulativeGraph/TablePreview.vue
// module id = null
// module chunks = 